import { Popover } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useSelector } from 'react-redux';

import API from 'configs/API';

import useStyles from '../styles';
import NotificationHeader from './NotificationHeader';
import NotificationList from './NotificationList';

const NotificationPopover = ({ anchorEl, onClose }) => {
  const classes = useStyles();
  const userId = useSelector((state) => state.auth.account.user.id);
  const { data: notifications = [] } = useQuery({
    queryKey: [API.AUTH.NOTIFICATION, null, userId],
  });

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClose={onClose}
      onClick={onClose}
      className={classes.popover}
    >
      <NotificationHeader notifications={notifications} />
      <NotificationList notifications={notifications} />
    </Popover>
  );
};

export default NotificationPopover;
